import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";

export const toggleGarageDrawer = actionCreator("garage/drawer/toggle");
